import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import ContentViewShopComponent from '#app/Component/ContentViewShopComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import { StateType } from '#app/Store';
import ShopCreateClientForm from '#app/View/Shop/Sale/components/ShopCreateClientForm';

type Client = {
  [key: string]: any;
};

const EditClient: React.FC = () => {
  const [loadingContent, setLoadingContent] = useState<boolean>(true);
  const authenticationReducer = useSelector((state: StateType) => state.AuthenticationReducer);
  const [client, setClient] = useState<Client>();
  const params = useParams<{ uuid: string }>();

  useEffect(() => {
    setLoadingContent(false);

    ApiHandler.get(
      {
        route: 'api_shop_sales_client_info',
        params: { uuid: params.uuid as string, shopId: authenticationReducer.shopSelected as string },
      },
      (response) => {
        if (response.status === 200) {
          setClient(response.data.client);
        } else {
          dispatch(
            SnackbarOpen({
              text: response.error?.message || "Une erreur inattendue s'est produite.",
              variant: 'error',
            }),
          );
        }
      },
    );
  }, []);

  return (
    <ContentViewShopComponent loading={loadingContent}>
      {client && <ShopCreateClientForm client={client} />}
    </ContentViewShopComponent>
  );
};

export default EditClient;
